import { Page } from "./_page";
import { PasswordForgottenModal } from "../_password_forgotten_modal";

export class CheckoutLoginPage extends Page {

	static PAGE_CLASS = "checkout-login-page";

	constructor() {
		super();
		this.addModal(new PasswordForgottenModal());
	}

}
